export const permissionMpping = {
  logoLook: "1894250309894840322", //logo查看
  logoBtn: "1894250309894840323", // logo定制操作
  contractLook: "1894247085565546496", // 合同查看
  contractBtn: "1894247085573935104", // 合同操作
  orderLook: "1894246668429537280", // 订单查看
  orderBtn: "1894246668429537281", // 订单操作
  walletLook: "1894246364631814144", // 钱包查看
  walletBtn: "1894246364636008448", // 钱包操作
  limitLook: "1894246004613726208", // 钱额度查看
  limitBtn: "1894246004613726209", // 钱额度操作
  informationLook: "1894245512932352000", // 我的资料查看
  informationBtn: "1894245512932352001", // 我的资料操作
  roleLook: "1894230398153822208", // 角色查看
  roleBtn: "1894230398158016512", // 角色操作
  memberLook: "1894231637511983104", // 认养管理查看
  memberBtn: "1894231637516177408", // 认养管理操作
  accountLook: "1894232108582653952", // 客户管理查看
  accountBtn: "1894232108595236864", // 客户管理操作
  inviteLook: "1894232726151938048", // 邀请记录查看
  inviteBtn: "1894232726156132352", // 邀请记录操作
  helpLook: "1894245055086198784", // 帮助中心查看
  helpBtn: "1894245055090393088", // 帮助中心操作
  consumeLook: "1894250309894840320", // 消耗数据查看
  consumeBtn: "1894250309894840321", // 消耗数据操作
  accountListLook: "1894248800524259328", // 账户列表查看
  accountListBtn: "1894248800524259329", // 账户列表操作
  RechargeLook: "1894249092787490816", // 充值记录查看
  RechargeBtn: "1894249092791685120", // // 充值记录操作
  TransferFundsLook: "1894249481448472576", // 跨媒体转款查看
  TransferFundsBtn: "1894249481448472577", // 跨媒体转款操作
  zeroClearingLook: "1894249877126623232", // 清零记录查看
  zeroClearingBtn: "1894249877130817536", // 清零记录操作
  openAccountLook: "1894247556103643136", // 开户申请查看
  openAccountBtn: "1894247556107837440", // 开户申请操作
  openAccountHistoryLook: "1894248062217666560", // 开户记录查看
  openAccountHistoryBtn: "1894248062221860864", // 开户记录操作
  openAccountBodyLook: "1894248388563947520", // 开户主体查看
  openAccountBodyBtn: "1894248388572336128", // 开户主体操作
  messageLook: "1894244545318912000", // 消息中心查看
  messageBtn: "1894244545323106304", // 消息中心操作
  DataConsumption: "1894227263331082240", // 消耗数据概览
  AdvertisingAccountDataStatistics: "1894227898344517632", // 广告账户数据统计
  FinancialOverview: "1894227898344517633", // 资金概览
  AccountBalanceWarning: "1894227898344517634", // 账户余额预警
};
